import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Grid,
  Divider
} from '@material-ui/core';
import AccessTimeIcon from '@material-ui/icons/AccessTime';


const useStyles = makeStyles(theme => ({
  root: {},
  imageContainer: {
    height: 64,
    width: 64,
    margin: '0 auto',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '5px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  image: {
    width: '100%'
  },
  statsItem: {
    display: 'flex',
    alignItems: 'center'
  },
  statsIcon: {
    color: theme.palette.icon,
    marginRight: theme.spacing(1)
  }
}));

const VacancyCard = props => {
  const { className, vacancy, recommendedDate, ...rest } = props;
  const { company, department, createdAt } = vacancy

  const classes = useStyles();

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent>
        <Typography
          align="center"
          gutterBottom
          variant="h4"
        >
          {department}
        </Typography>
        <Typography
          align="center"
          variant="body1"
        >
          {company}
        </Typography>
      </CardContent>
      <Divider />
      <CardActions>
        <Grid
          container
          justifyContent="space-between"
        >
          <Grid
            className={classes.statsItem}
            item
          >
            <AccessTimeIcon className={classes.statsIcon} />
            <Typography
              display="inline"
              variant="body2"
            >
              Añadida {moment(recommendedDate).format('DD/MM/YYYY')}
            </Typography>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
};

VacancyCard.propTypes = {
  className: PropTypes.string,
  vacancy: PropTypes.object.isRequired
};

export default VacancyCard;
